@if (formGroup) {
<form [formGroup]="formGroup">
  <mat-form-field class="w-100">
    <mat-label>{{ 'VOUCHER.CLIENT_INSTALLATIONS.CLIENT_ID' | translate }}</mat-label>
    <input
      matInput
      [formControl]="formGroup.controls.client_id"
      [placeholder]="'VOUCHER.CLIENT_INSTALLATIONS.CLIENT_ID' | translate"
      maxlength="255"
    />
    @if (formGroup.controls.client_id.hasError('required') && formGroup.controls.client_id.touched) {
    <mat-error>
      {{ 'VALIDATION.REQUIRED' | translate }}
    </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>{{ 'VOUCHER.CLIENT_INSTALLATIONS.APPLICATION_TYPE' | translate }}</mat-label>
    <mat-select [formControl]="formGroup.controls.type">
      <mat-option [value]="undefined">{{ 'VOUCHER.CLIENT_INSTALLATIONS.SELECT' | translate }}</mat-option>
      @for (type of typeList; track type) {
      <mat-option [value]="type">{{ type }}</mat-option>
      }
    </mat-select>
    @if (formGroup.controls.type.hasError('required') && formGroup.controls.type.touched) {
    <mat-error>
      {{ 'VALIDATION.REQUIRED' | translate }}
    </mat-error>
    }
  </mat-form-field>

  @if (formGroup.controls.type.value === 'Docker') {
  <mat-form-field class="w-100">
    <mat-label>{{ 'VOUCHER.CLIENT_INSTALLATIONS.INSTANCES' | translate }}</mat-label>
    <input
      matInput
      type="number"
      [formControl]="formGroup.controls.instances"
      [placeholder]="'VOUCHER.CLIENT_INSTALLATIONS.INSTANCES' | translate"
    />
    @if (formGroup.controls.instances.hasError('required') && formGroup.controls.instances.touched) {
    <mat-error>
      {{ 'VALIDATION.REQUIRED' | translate }}
    </mat-error>
    }
  </mat-form-field>
  }
</form>
}
